export default __webpack_public_path__ + "static/media/CorrectAnswer1.bd263528.mp3";